import { useEffect } from "react";
import { refetchBus, buildRefetchKey } from "@ippon/shared-utils";

/**
 * refetchBus の `${entity}:${id}` キーを購読し、emit 時に callback を呼ぶ汎用 hook。
 *
 * 使い方:
 *   const { id } = useParams();
 *   useRefetchOn("property", id, fetchDetail);
 *
 * - entity / id のいずれかが空なら購読しない (詳細ページ初期化中の安全弁)。
 * - callback は呼び出し側で useCallback 等によりメモ化することを推奨
 *   (deps に入るため、不安定な参照だと毎レンダで subscribe/unsubscribe が走る)。
 */
export const useRefetchOn = (
  entity: string | null | undefined,
  id: string | number | null | undefined,
  callback: () => void
): void => {
  useEffect(() => {
    if (!entity || id === null || id === undefined || id === "") return;
    const key = buildRefetchKey(entity, id);
    const unsubscribe = refetchBus.subscribe(key, callback);
    return unsubscribe;
  }, [entity, id, callback]);
};
